module.exports = __webpack_public_path__ + "static/media/person1.d0de78b7.jpg";